export enum AddressType {
  KEPLR='KEPLR',
  METAMASK='METAMASK'
}
